export default __webpack_public_path__ + "cb2184bcf38659a8a78af698967d493e.png";